import { render, staticRenderFns } from "./choosePinTuanGoods.vue?vue&type=template&id=2968118e&"
import script from "./choosePinTuanGoods.vue?vue&type=script&lang=js&"
export * from "./choosePinTuanGoods.vue?vue&type=script&lang=js&"
import style0 from "./choosePinTuanGoods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports